import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyDyK-Uc8H8wu8uns5vUk0_f4VnWcRUHaJg",
    authDomain: "holdstation-fd4c7.firebaseapp.com",
    projectId: "holdstation-fd4c7",
    storageBucket: "holdstation-fd4c7.firebasestorage.app",
    messagingSenderId: "509763890011",
    appId: "1:509763890011:web:cb965869080e64891ac87e",
    measurementId: "G-BGSEVFYFDM"
};

const app = initializeApp(firebaseConfig);
export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 60_000;
remoteConfig.defaultConfig = {
  eggs_vault_on: '0',
  eggs_vault_banner_on: '0',
};
